import { useId } from "react";

interface OverlayControlProps {
  value: string;
  onChange: (value: string) => void;
}

const OPTIONS = [
  { label: "None", value: "none" },
  { label: "Dark -- Light", value: "light" },
  { label: "Dark -- Medium", value: "medium" },
  { label: "Dark -- Heavy", value: "heavy" },
  { label: "Light -- Glass", value: "light-glass" },
  { label: "Light -- Frost", value: "light-frost" },
];

export function OverlayControl({ value, onChange }: OverlayControlProps) {
  const id = useId();
  return (
    <div className="mb-[18px]">
      <label
        htmlFor={id}
        className="block text-[11px] font-bold tracking-[0.05em] uppercase text-ink-4 mb-[7px]"
      >
        Overlay
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-ink-6 rounded-[9px] bg-paper px-[11px] py-2 text-[12px] text-ink focus:outline-none focus:border-tide focus:ring-[3px] focus:ring-tide-s transition-all"
      >
        {OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
